let districtOfficeOptions = [
  { value: "", label: "- All Districts -" },
  { value: "MV?", label: "----MVD-Mississippi Valley Division" },
  { value: "MVK", label: "------MVK-Vicksburg District" },
  { value: "MVM", label: "------MVM-Memphis District" },
  { value: "MVN", label: "------MVN-New Orleans District" },
  { value: "MVP", label: "------MVP-St. Paul District" },
  { value: "MVR", label: "------MVR-Rock Island District" },
  { value: "MVS", label: "------MVS-St. Louis District" },
  { value: "NA?", label: "----NAD-North Atlantic Division" },
  { value: "NAB", label: "------NAB-Baltimore District" },
  { value: "NAE", label: "------NAE-New England District" },
  { value: "NAN", label: "------NAN-New York District" },
  { value: "NAO", label: "------NAO-Norfolk District" },
  { value: "NAP", label: "------NAP-Philadelphia District" },
  { value: "NW?", label: "----NWD-Northwestern Division" },
  { value: "NWK", label: "------NWK-Kansas City District" },
  { value: "NWO", label: "------NWO-Omaha District" },
  { value: "NWP", label: "------NWP-Portland District" },
  { value: "NWS", label: "------NWS-Seattle District" },
  { value: "NWW", label: "------NWW-Walla Walla District" },
  { value: "LR?", label: "----LRD-Great Lakes and Ohio River Division" },
  { value: "LRB", label: "------LRB-Buffalo District" },
  { value: "LRC", label: "------LRC-Chicago District" },
  { value: "LRE", label: "------LRE-Detroit District" },
  { value: "LRH", label: "------LRH-Huntington District" },
  { value: "LRL", label: "------LRL-Louisville District" },
  { value: "LRN", label: "------LRN-Nashville District" },
  { value: "LRP", label: "------LRP-Pittsburgh District" },
  { value: "PO?", label: "----POD-Pacific Ocean Division" },
  { value: "POA", label: "------POA-Alaska District" },
  { value: "POH", label: "------POH-Honolulu District" },
  { value: "SA?", label: "----SAD-South Atlantic Division" },
  { value: "SAA", label: "------SAA-Caribbean District" },
  { value: "SAC", label: "------SAC-Charleston District" },
  { value: "SAJ", label: "------SAJ-Jacksonville District" },
  { value: "SAM", label: "------SAM-Mobile District" },
  { value: "SAS", label: "------SAS-Savannah District" },
  { value: "SAW", label: "------SAW-Wilmington District" },
  { value: "SP?", label: "----SPD-South Pacific Division" },
  { value: "SPA", label: "------SPA-Albuquerque District" },
  { value: "SPL", label: "------SPL-Los Angeles District" },
  { value: "SPK", label: "------SPK-Sacramento District" },
  { value: "SPN", label: "------SPN-San Francisco District" },
  { value: "SW?", label: "----SWD-Southwestern Division" },
  { value: "SWF", label: "------SWF-Fort Worth District" },
  { value: "SWG", label: "------SWG-Galveston District" },
  { value: "SWL", label: "------SWL-Little Rock District" },
  { value: "SWT", label: "------SWT-Tulsa District" },
];

export default districtOfficeOptions;
